export enum TipoDeImportacion {
    BajasAltas,
    SoloAltas,
    SoloTrabajadores,
    SoloBajas,
    SoloDatos,
    SoloTrabajadoresCon,
    SoloTrabajadoresPlantilla,
    ImpQuironPrevencion,
}

export enum SinTelefono {
    Nada,
    NoSeImporta,
    DejaLaTarea,
    ComprobarDireccion = 5,
    TelefonoIncorrecto,
    NoneSelected = -1,
}

export enum Tareas {
    SinTarea,
    PrimerContactoTelefonico,
    PrimeraVisita,
    PrimerContacto,
    ContactoAdministrativo,
    SegunEmpresa,
    SegunCriterios = 7,
    NoneSelected = -1,
}

export enum AvisoBaja {
    NoIncluirAvisos,
    BajasNuevas,
    AvisosDeBaja,
    NoneSelected = -1,
}